import { Product } from '@inter-ikea-storageone/range';
import { useAppDispatch } from 'ducks/hooks';
import { showProductDetails } from 'ducks/layout';
import React from 'react';

export default function useOnInfoClicked(product: Product, cluster?: Product[] | undefined) {
  const dispatch = useAppDispatch();

  const onInfoClicked = (event: React.MouseEvent<HTMLElement>) => {
    const { width, top, left } = event.currentTarget.getBoundingClientRect();

    dispatch(
      showProductDetails({
        productId: product.coreProductId,
        boundingBox: { width, top, left },
        cluster
      })
    );
  };
  return onInfoClicked;
}
